module.exports = __webpack_public_path__ + "img/scratch.4724bbc6.svg";